module.exports = __webpack_public_path__ + "img/sport-4.4035b147.jpg";